import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import {InstiService} from '../../insti/insti.service';

@Injectable({
  providedIn: 'root'
})
export class FullService  extends InstiService{

  constructor( 
    protected http: HttpClient
      ) { 
   super(); 
  }
}
